import { useRequiredContext } from "@suse-o11y/use-required-context";

import { NotificationContext } from "./_context";

function useNotificationClose(): VoidFunction {
	return useRequiredContext(NotificationContext, {
		providerName: "Notification",
	});
}

export { useNotificationClose };
